if (!customElements.get('article-tables')) {
  customElements.define(
    'article-tables',
    class ArticleTables extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('table').forEach((table) => this.prepareTable(table));
      }

      prepareTable(table) {
        if (table.dataset.stacked !== undefined) return;

        const rows = Array.from(table.rows);
        if (rows.length < 2) return;

        // Use the thead row if present, otherwise treat the first row as the header.
        const headerRow = table.tHead?.rows[0] || rows[0];
        headerRow.setAttribute('data-table-header', '');

        // Merged cells can't be mapped reliably to a single header — skip stacking.
        const hasMergedCells = Array.from(table.querySelectorAll('td, th')).some(
          (cell) => cell.colSpan > 1 || cell.rowSpan > 1
        );
        if (hasMergedCells) return;

        const labels = Array.from(headerRow.cells).map((cell) => cell.textContent.trim());
        if (labels.length < 2) return;

        rows.forEach((row) => {
          if (row === headerRow) return;
          Array.from(row.cells).forEach((cell, index) => {
            if (labels[index]) cell.setAttribute('data-label', labels[index]);
          });
        });

        table.setAttribute('data-stacked', '');
      }
    }
  );
}
